import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerDashboardData } from "../actions/dashboardActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Spinner from "../components/Spinner";

export default function CustomerDashboardHeader() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const data = useSelector((state) => state.dashboard.customerDashboardData);
  const { t } = useTranslation();
  
  useEffect(() => {
    if (user?.id) {
      dispatch(getCustomerDashboardData(user.id));
    }
  }, [dispatch, user?.id]);

  if (!data) return <Spinner showLoader={true} />; 

  const renderCard = (icon, bgColor, value, label, extra = null) => (
  <div className="col-xl-3 col-md-6 mb-1" style={{ paddingLeft: 5, paddingRight: 5 }}>
    <div
      className="card d-flex flex-row align-items-center p-3"
      style={{ minHeight: 100 }}
    >
      <div
        className={`rounded-circle ${bgColor} text-white d-flex align-items-center justify-content-center flex-shrink-0`}
        style={{ width: 60, height: 60 }}
      >
        <FontAwesomeIcon icon={icon} size="lg" />
      </div>

      <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center ml-3">
        <div className="font-weight-bold">{value}</div>
        <div className="text-muted">{label}</div>
        {extra && <small className="text-muted">{extra}</small>}
      </div>
    </div>
  </div>
);



  return (
    <div className="col-12" style={{ paddingBottom: "20px" }}>
      <div className="row">
        {renderCard(faShoppingCart, "bg-success", data.lifeTimeTotalPoints, t("LifeTime Points"))}
        {renderCard(faShoppingCart, "bg-success", data.activeTotalPoints, t("Active Points"))}
        {renderCard(faCalendarAlt, "bg-info", data.customerSince, t("Customer Since"))}
        {data.lastPurchase && renderCard(faCalendarAlt,"bg-danger", data.lastPurchase, t("Last Purchase"), data.lastPurchaseConsultantName )}
      </div>
    </div>
  );
}
